module.exports = __webpack_public_path__ + "static/media/northern-blue.4e0b552b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/northern-blue.jpeg
// module id = 2039
// module chunks = 0